/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';

export type ModalContextType = {
  modalName?: string;
  modalPayload?: any;
  openModal: (name: string, payload?: any, settings?: ModalContextSettingType) => void;
  closeModal: (payload?: any, settings?: ModalContextSettingType) => void;
};

export type ModalContextSettingType = {
  onBeforeOpen?: (payload: any) => void;
  onAfterOpen?: (payload: any) => void;
  onBeforeClose?: (payload: any, current) => void;
  onAfterClose?: (payload: any, current) => void;
};

const initialSettings: ModalContextSettingType = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onBeforeOpen: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onAfterOpen: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onBeforeClose: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onAfterClose: () => {}
};

export type ModalContextProviderType = {
  children: React.ReactNode;
};

const ModalContext = createContext<ModalContextType>({
  openModal: () => null,
  closeModal: () => null
});

export function ModalContextProvider({ children }: ModalContextProviderType) {
  const [modalName, setModalName] = useState(undefined);
  const refPayload = useRef({});
  const refSettings = useRef(initialSettings);

  const openModal = useCallback((name, payload = {}, settings = initialSettings) => {
    refSettings.current = {
      ...initialSettings,
      ...settings
    };
    // @ts-ignore
    refSettings.current.onBeforeOpen(payload);
    refPayload.current = payload;
    setModalName(name);
    // @ts-ignore
    return refSettings.current.onAfterOpen(refPayload.current);
  }, []);

  const closeModal = useCallback(({ fromModal = false, ...args } = {}) => {
    // @ts-ignore
    refSettings.current.onBeforeClose({ ...args,fromModal }, refPayload.current);
    setModalName(undefined);
    // @ts-ignore
    return refSettings.current.onAfterClose({ ...args,fromModal }, refPayload.current);
  }, []);

  const value = useMemo<ModalContextType>(
    () => ({
      modalName,
      modalPayload: refPayload.current,
      openModal,
      closeModal
    }),
    [modalName, openModal, closeModal]
  );
  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
}

export const useModalContext = () => useContext(ModalContext);

export default ModalContextProvider;
